var Chart = require('chart.js');
// const utils = require('frontend-controller/lib/utils')

module.exports = {
	config: {
		sendStatusChartProperties: {
			type: 'doughnut',
			data: [],
			options: {
				legend: {
					display: false
					// position: 'right',
				},
				// events: [],
				tooltips: {
					enabled: false
				},
				// animation: {
				// 	duration: 0 // general animation time
				// },
				hover: {
					animationDuration: 0 // duration of animations when hovering an item
				},
				cutoutPercentage: 3,
				// responsiveAnimationDuration: 0, // animation duration after a resize
				// scales: {
				// 	xAxes: [{
				// 		display: false,
				// 		offset: false,
				// 		ticks: {
				// 			beginAtZero:true,
				// 			min: 0,
				// 			max: 100
				// 			// fontFamily: "'Open Sans Bold', sans-serif",
				// 			// fontSize:11
				// 		},
				// 		scaleLabel:{
				// 			display:false
				// 		},
				// 		gridLines: {
				// 			display: false,
				// 			offset: false,
				// 			offsetGridLines: false,
				// 			drawBorder: false,
				// 		},
				// 		stacked: true
				// 	}],
				// 	yAxes: [{
				// 		display: false,
				// 		// offset: false,
				// 		gridLines: {
				// 			display: false,
				// 			offset: false,
				// 			offsetGridLines: false,
				// 			drawBorder: false,
				// 			// color: "#fff",
				// 			// zeroLineColor: "#fff",
				// 			// zeroLineWidth: 0
				// 		},
				// 		ticks: {
				// 			beginAtZero:true,
				// 			// fontFamily: "'Open Sans Bold', sans-serif",
				// 			// fontSize:11
				// 		},
				// 		scaleLabel:{
				// 			display:false
				// 		},
				// 		stacked: true
				// 	}]
				// },
				// legend:{
				// 	display:false,
				// 	labels: {
				// 		padding: 0
				// 	}
				// },
				//
				//
				//
				// // animation: {
				// // 	onComplete: function () {
				// // 		var chartInstance = this.chart;
				// // 		var ctx = chartInstance.ctx;
				// // 		ctx.textAlign = "left";
				// // 		ctx.font = "9px Open Sans";
				// // 		ctx.fillStyle = "#fff";
				// //
				// // 		Chart.helpers.each(this.data.datasets.forEach(function (dataset, i) {
				// // 			var meta = chartInstance.controller.getDatasetMeta(i);
				// // 			Chart.helpers.each(meta.data.forEach(function (bar, index) {
				// // 				data = dataset.data[index];
				// // 				if(i==0){
				// // 					ctx.fillText(data, 50, bar._model.y+4);
				// // 				} else {
				// // 					ctx.fillText(data, bar._model.x-25, bar._model.y+4);
				// // 				}
				// // 			}),this)
				// // 		}),this);
				// // 	}
				// // },
				// // pointLabelFontFamily : "Quadon Extra Bold",
				// // scaleFontFamily : "Quadon Extra Bold",
				//
				//
				//
				// maintainAspectRatio: false,
				aspectRatio: 1,
				// responsive: false,
				layout: {
					padding: {
						left: 0,
						right: 0,
						top: 0,
						bottom: 0
					}
				}
			}
		},
		// barOptionsByStatus: {
		// 	sent: {
		// 		backgroundColor: "rgba(144,193,144,1)",
		// 		categoryPercentage: 1,
		// 		barPercentage: 1,
		// 	},
		// 	received: {
		// 		backgroundColor: "rgba(0,102,0,1)",
		// 		categoryPercentage: 1,
		// 		barPercentage: 1,
		// 	},
		// 	undeliverable: {
		// 		backgroundColor: "rgba(178,0,0,1)",
		// 		categoryPercentage: 1,
		// 		barPercentage: 1,
		// 	}
		// }
	},

	model: {
		chartProperties: {}
	},

	methods: {
		initChart: function(){
			if(!this.model.sendStatusChart && this.$.length > 0){
				this.model.sendStatusChart = new Chart(this.$.find('> .canvasContainer > canvas.sendStatusChart'), this.model.chartProperties);
			}
		}
	},

	hooks: {
		update: function($element, options) {
			var self = this;

			this.initChart();

			if(self.model.sendStatusChart && options.mailingResourceData){
				var mailingAttributes = options.mailingResourceData.attributes || {};
				var stats = mailingAttributes.stats || {};

				var nrOfRecipients = mailingAttributes.statsRecipients || 0;
				var nrOfSent = stats.processed || 0;
				var nrOfReceived = stats.sent || 0;
				var nrOfUndeliverables = stats.hardBounce || 0;
				var nrOfUniqueViews = stats.uniqueSubscriberViews || 0;
				var nrOfUnsubscribed = mailingAttributes.statsUnsubscribed || 0;

				// softBounces will be treated as sent but not received until the mailing sendStatus is "finished"
				if (mailingAttributes.sendStatus === 'finished') {
					nrOfUndeliverables += (stats.softBounce || 0);
				} else {
					nrOfSent += (stats.softBounce || 0);
				}

				var nrOfElements = nrOfSent + nrOfReceived + nrOfUndeliverables;

				if(nrOfElements > 0 || nrOfRecipients > 0){
					self.model.sendStatusChart.data.labels = [
						`Empfänger (${nrOfRecipients})`,

						`Versandt (${nrOfSent})`,
						`Zugestellt (${nrOfReceived})`,
						`Unzustellbar (${nrOfUndeliverables})`,

						`Gelesen (${nrOfUniqueViews})`,
						'',

						`Abgemeldet (${nrOfUnsubscribed})`,
						''
					];
					if (nrOfRecipients > 0) {
						self.model.sendStatusChart.data.datasets[0].data = [nrOfRecipients, 0, 0, 0, 0, 0, 0, 0];
					} else {
						self.model.sendStatusChart.data.datasets[0].data = [];
					}
					if (nrOfElements > 0) {
						self.model.sendStatusChart.data.datasets[1].data = [0, nrOfSent, nrOfReceived, nrOfUndeliverables, 0, 0, 0, 0];
					} else {
						self.model.sendStatusChart.data.datasets[1].data = [];
					}
					if (nrOfUniqueViews > 0) {
						self.model.sendStatusChart.data.datasets[2].data = [0, 0, 0, 0, nrOfUniqueViews, nrOfElements-nrOfUniqueViews, 0, 0];
					} else {
						self.model.sendStatusChart.data.datasets[2].data = [];
					}
					if (nrOfUnsubscribed > 0) {
						self.model.sendStatusChart.data.datasets[3].data = [0, 0, 0, 0, 0, 0, nrOfUnsubscribed, nrOfElements-nrOfUnsubscribed];
					} else {
						self.model.sendStatusChart.data.datasets[3].data = [];
					}
				} else {
					self.model.sendStatusChart.data.labels = [];
					self.model.sendStatusChart.data.datasets[0].data = [];
					self.model.sendStatusChart.data.datasets[1].data = [];
					self.model.sendStatusChart.data.datasets[2].data = [];
					self.model.sendStatusChart.data.datasets[3].data = [];
				}

				var $legend = $element.find('.legend');
				$legend.html(self.model.sendStatusChart.generateLegend());
				$legend.find('ul > li:nth-child(6), ul > li:nth-child(8)').hide();
				if(nrOfSent <= 0){
					$legend.find('ul > li:nth-child(2)').hide();
				}
				self.model.sendStatusChart.update();
			}
		},

		attach: function($element, options){
			var self = this;

			// in case of refreshes the chart-dom-binding has to be renewed
			if (self.model.sendStatusChart && (options || {}).refresh){
				self.model.sendStatusChart.destroy();
				delete self.model.sendStatusChart;
			}
			if(!self.model.sendStatusChart){
				self.model.chartProperties = self.config.sendStatusChartProperties;
				self.model.chartProperties.data = {
					datasets: [{
						data: [],
						backgroundColor: [
							'#666666',

							'#90C190',
							'#006600',
							'#B20000',

							'#ECCB00',
							'#F9F9F9',

							'#3076B2',
							'#F9F9F9',
						],
						hoverBackgroundColor: [
							'#666666',

							'#90C190',
							'#006600',
							'#B20000',

							'#ECCB00',
							'#F9F9F9',

							'#3076B2',
							'#F9F9F9',
						],
						borderColor: [
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
						],
						categoryPercentage: 1,
						barPercentage: 1,
					},{
						data: [],
						backgroundColor: [
							'#666666',

							'#90C190',
							'#006600',
							'#B20000',

							'#ECCB00',
							'#F9F9F9',

							'#3076B2',
							'#F9F9F9',
						],
						hoverBackgroundColor: [
							'#666666',

							'#90C190',
							'#006600',
							'#B20000',

							'#ECCB00',
							'#F9F9F9',

							'#3076B2',
							'#F9F9F9',
						],
						borderColor: [
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
						],
						categoryPercentage: 1,
						barPercentage: 1,
					},{
						data: [],
						backgroundColor: [
							'#666666',

							'#90C190',
							'#006600',
							'#B20000',

							'#ECCB00',
							'#F9F9F9',

							'#3076B2',
							'#F9F9F9',
						],
						hoverBackgroundColor: [
							'#666666',

							'#90C190',
							'#006600',
							'#B20000',

							'#ECCB00',
							'#F9F9F9',

							'#3076B2',
							'#F9F9F9',
						],
						borderColor: [
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
						],
						categoryPercentage: 1,
						barPercentage: 1,
					},{
						data: [],
						backgroundColor: [
							'#666666',

							'#90C190',
							'#006600',
							'#B20000',

							'#ECCB00',
							'#F9F9F9',

							'#3076B2',
							'#F9F9F9',
						],
						hoverBackgroundColor: [
							'#666666',

							'#90C190',
							'#006600',
							'#B20000',

							'#ECCB00',
							'#F9F9F9',

							'#3076B2',
							'#F9F9F9',
						],
						borderColor: [
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
							'#F9F9F9',
						],
						categoryPercentage: 1,
						barPercentage: 1,
					}]
				};
				self.initChart();
			}

			// if(!options.refresh) {
			// 	var dataSets = [];
			// 	// console.log(self.resourceData);
			// 	var resourceAttributes = (self.resourceData || {}).attributes || {}
			// 	var stats = resourceAttributes.stats || {}
			// 	var nrOfElements, dataSet;
			//
			// 	var nrOfAll = stats.all || 1;
			// 	var nrOfSent = stats.processed || 0;
			// 	var nrOfReceived = stats.sent || 0;
			// 	var nrOfUndeliverables = stats.hardBounce || 0;
			//
			// 	// softBounces will be treated as sent but not received until the mailing sendStatus is "finished"
			// 	if (resourceAttributes.sendStatus === 'finished') {
			// 		nrOfUndeliverables += (stats.softBounce || 0);
			// 	} else {
			// 		nrOfSent += (stats.softBounce || 0);
			// 	}
			//
			// 	if(nrOfSent > 0){
			// 		nrOfElements = Math.round(nrOfSent / nrOfAll * 250) / 2.5; // scale has 250px width. prevent half pixels between bars.
			// 		if(nrOfElements > 0){
			// 			dataSet = utils.copy(self.config.barOptionsByStatus.sent);
			// 			dataSet.data = [nrOfElements];
			// 			dataSets.push(dataSet);
			// 		}
			// 	}
			// 	if(nrOfReceived > 0){
			// 		nrOfElements = Math.round(nrOfReceived / nrOfAll * 250) / 2.5; // scale has 250px width. prevent half pixels between bars.
			// 		if(nrOfElements > 0){
			// 			dataSet = utils.copy(self.config.barOptionsByStatus.received);
			// 			dataSet.data = [nrOfElements];
			// 			dataSets.push(dataSet);
			// 		}
			// 	}
			// 	if(nrOfUndeliverables > 0){
			// 		nrOfElements = Math.round(nrOfUndeliverables / nrOfAll * 250) / 2.5; // scale has 250px width. prevent half pixels between bars.
			// 		if(nrOfElements > 0){
			// 			dataSet = utils.copy(self.config.barOptionsByStatus.undeliverable);
			// 			dataSet.data = [nrOfElements];
			// 			dataSets.push(dataSet);
			// 		}
			// 	}
			//
			// 	new Chart($element.find('> canvas'), {
			// 		type: 'horizontalBar',
			// 		data: {
			// 			labels: [],
			// 			datasets: dataSets
			// 		},
			//
			// 		options: self.config.chartOptions,
			// 	});
			// }
		}
	}
};
